import { debounce } from 'lodash'
import { parse } from 'tinyduration'

import axiosClient from '../service/axiosClient'
import {
    AccountingSystem,
    accountingSystemExtension,
    defaultAccountingSystem,
} from '../types/AccountingSystem'
import ClientDTO from '../types/Client'
import { CorporateBody, CorporateOption } from '../types/Corporate'

export const fetchClients = async (includeInactive = false): Promise<ClientDTO[]> => {
    try {
        const response = await axiosClient.get('client')
        console.log('response', response)
        if (includeInactive) {
            return response.data
        }
        return response.data.filter((client: ClientDTO) => !!client.active)
    } catch (error) {
        console.log('error', error)
        throw error
    }
}

export function toDateString(input: any): string | undefined {
    if (!(input instanceof Date) && typeof input !== 'string') {
        return undefined
    }
    
    const date = new Date(input)


    // Skontroluj, či je to platný dátum
    if (isNaN(date.getTime())) {
        return undefined
    }

    // Získaj jednotlivé časti dátumu
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // mesiace sú 0-indexované
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export function createDate(days: number, months: number, years: number) {
    const date = new Date()
    date.setDate(date.getDate() + days)
    date.setMonth(date.getMonth() + months)
    date.setFullYear(date.getFullYear() + years)
    return date
}

export function getDuration(durationString: string) {
    const durationObj = parse(durationString)

    return durationObj
}

export function dateToIsoString(date: Date): string {

    const utcTimeInMilliseconds = date.getTime()

    // Get the local timezone offset from UTC in milliseconds
    const timezoneOffsetInMilliseconds = date.getTimezoneOffset() * 60 * 1000

    // Create a new date subtracting the timezone offset from the local time
    const dateMinusTimezoneOffset = new Date(utcTimeInMilliseconds - timezoneOffsetInMilliseconds)

    // Convert the adjusted date to an ISO string, which is the format the API expects
    const isoString = dateMinusTimezoneOffset.toJSON()

    return isoString
}

export function generateAndDownloadInvoicePdfFile(id: string, invoiceId: string) {
    axiosClient.get('/invoice/generate/' + id).then(response => {
        axiosClient({
            url: '/invoice/download/' + invoiceId,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.data)

            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute('download', 'faktura_' + invoiceId + '.pdf') //or any other extension
            document.body.appendChild(link)
            link.click()

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
        })
    })
}

export function generateAndDownloadInvoiceXmlFile(id: string, invoiceId: string,
                                                  system: AccountingSystem = defaultAccountingSystem) {
    const params = {params: {system}}

    axiosClient.get('/invoice-export/xml/' + id, params).then(response => {
        axiosClient({
            url: '/invoice-export/download/' + invoiceId,
            method: 'GET',
            responseType: 'blob',
            params: {system},
        }).then((response) => {
            const href = URL.createObjectURL(response.data)

            const link = document.createElement('a')
            link.href = href
            link.setAttribute('download',
                'faktura_' + invoiceId + '.' + accountingSystemExtension(system))
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            URL.revokeObjectURL(href)
        })
    })
}

export const money = new Intl.NumberFormat('sk-SK',
    {style: 'currency', currency: 'EUR'})

export   const loadOptionsForCompanySelector = debounce((
    inputValue: string,
    callback: (options: CorporateOption[]) => void
) => {
    // Goes through Amani rather than straight to the register: the browser is blocked by that
    // register's CORS policy, and calling it from here meant shipping the access token to
    // everyone who loaded the site.
    axiosClient.get('corporate-body/search', {
        params: {q: inputValue}
    }).then((response) => {
        callback(response.data.map((item: CorporateBody) => {
                return {
                    value: item,
                    label: item.name
                } as CorporateOption
            }
        ))
    }).catch(() => callback([]))
}, 800)
